import {Box, FormControl, InputLabel, MenuItem, Select} from '@mui/material';
import {StudyStatus} from '@cp/model';
import {env} from '../../config/env';

export interface DropdownStudyStatusProps {
  status?: StudyStatus;
  /** change of status, undefined/null means any status */
  onChange: (status?: StudyStatus) => void;
  /** Whether to show "All Statuses" option (for optional status) */
  allowAll?: boolean;
  /** Filter available statuses */
  availableStatuses?: StudyStatus[];
  /** Disable the dropdown */
  disabled?: boolean;
  /** Full width control */
  fullWidth?: boolean;
  /** Minimum width */
  minWidth?: number;
  /** Size of the select */
  size?: 'small' | 'medium';
}

export default function DropdownStudyStatus({
  status,
  onChange,
  allowAll = false,
  availableStatuses,
  disabled = false,
  fullWidth = true,
  minWidth,
  size = 'medium',
}: DropdownStudyStatusProps) {
  const statuses = availableStatuses || Object.values(StudyStatus);
  const displayValue = status || '';

  return (
    <FormControl
      fullWidth={fullWidth}
      size={size}
      sx={minWidth ? {minWidth} : undefined}
      data-testid="dropdown-study-status"
    >
      <InputLabel>Status</InputLabel>
      <Select
        value={displayValue}
        onChange={(e) => onChange(e.target.value ? (e.target.value as StudyStatus) : undefined)}
        label="Status"
        disabled={disabled}
      >
        {allowAll && (
          <MenuItem value="">
            <em>All Statuses</em>
          </MenuItem>
        )}
        {statuses.map((statusValue) => {
          const statusConfig = env.study.status[statusValue] || env.study.unknownStatus;
          return (
            <MenuItem key={statusValue} value={statusValue}>
              <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                <Box
                  sx={{
                    width: 12,
                    height: 12,
                    borderRadius: '50%',
                    bgcolor: statusConfig.color,
                  }}
                />
                {statusConfig.label}
              </Box>
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
}
